export enum PermissionType {
	read = 'read',
	create = 'create',
	import = 'import',
	modify = 'modify',
	delete = 'delete',
	export = 'export',
	archive = 'archive',
	unarchive = 'unarchive',
	share = 'share',
}

export const AnyLeafType = '*';

export interface PermissionId<TLeafTypes extends string = string> {
	ridLeafType: TLeafTypes;
	permissionType: PermissionType;
	toString(): string;
}

export class PermissionId<TLeafTypes extends string = string>
	implements PermissionId<TLeafTypes>
{
	public constructor(
		public ridLeafType: TLeafTypes,
		public permissionType: PermissionType
	) {}

	public toString() {
		return `${this.ridLeafType}:${this.permissionType}`;
	}

	public static parse(permission: string) {
		const [ridLeafType, permissionType] = permission.split(':');
		return new PermissionId(ridLeafType, permissionType as PermissionType);
	}

	public isGrantedBy(compared: PermissionId) {
		return (
			[AnyLeafType, this.ridLeafType].includes(compared.ridLeafType) &&
			compared.permissionType === this.permissionType
		);
	}
}

export interface RAMLikeRecord {
	users: Record<string, UserACL>;
}

export interface UserACL {
	permissions: PermissionId[];
}
